import { render, staticRenderFns } from "./VideoWeather.vue?vue&type=template&id=10cff3f4&"
import script from "./VideoWeather.vue?vue&type=script&lang=js&"
export * from "./VideoWeather.vue?vue&type=script&lang=js&"
import style0 from "./VideoWeather.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports